import React, { useEffect, useState } from 'react';
import { getRemoteConfigSelector } from '../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getWhMetaDataReducerSlice } from '../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';

/**
 * This is reusable component to select reason for reschedule
 * @param {*} props 
 * @returns 
 */
const SelectRescheuleReason = (props) => {
    const { rescheduleReason, setRescheduleReason, onSubmit, showButton = false, type, errorMsg = null, IDWarehouse, showTitle=true } = props;
    const dispatch = useDispatch();
    const user = useSelector(getUserSelector)
    const { cu_id, selectedWarehouse } = user;
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { massCancelReasonList } = whMetaData;
    const [reasons, setReasons] = useState([]);
    const [error, setError] = useState(null);

    const [loading, setLoading] = useState(true); // ADDED

    useEffect(() => {
        const warehouseId = selectedWarehouse?.ID || IDWarehouse;
        if (warehouseId) {
            setLoading(true); // ADDED

            dispatch({
                type: sagaActions.MANAGE_MASS_CANCEL_REASON,
                payload: {
                    CRUDTYPE: 'R',
                    IDWarehouse: warehouseId,
                    UserName: cu_id
                }
            });
        }

        return () => {
            dispatch({ type: sagaActions.RESET_MASS_CANCEL_REASON });
        }
    }, [selectedWarehouse?.ID, IDWarehouse]);

    useEffect(() => {
        let reasonOptions = [];
        if (massCancelReasonList?.length > 0) {
            reasonOptions = [...massCancelReasonList].sort(
                (a, b) => a.ReasonCode.localeCompare(b.ReasonCode)
            );
        }
        else if (allConfigration['ReasonForRescheduleOrCancel']?.length) {
            reasonOptions = allConfigration['ReasonForRescheduleOrCancel']
                .slice(1, -1)
                .split(',')
                .sort();
        }

        setReasons(reasonOptions);

        // ADDED (you can remove delay later)
        setTimeout(() => {
            setLoading(false);
        }, 0);

    }, [massCancelReasonList, allConfigration]);

    /**
     * useEffect to handle error state
     */
    useEffect(() => {
        setError(errorMsg)
    }, [errorMsg])
    
    /**
     * Function to handle change in select 
     * @param {*} e 
     */
   function handleChange(e) {
    const selectedIndex = e.target.value;

    if (selectedIndex === "Select a reason") {
        setRescheduleReason(null);
    } else {
        const rawReason = reasons[selectedIndex];

        const reasonText =
            typeof rawReason === "string"
                ? rawReason
                : rawReason?.ReasonDescription;

        setRescheduleReason(reasonText);
    }
}

    /**
     * Function to handle next button click 
     */
    function nextHandler(){
        if (validate()) {
            onSubmit();
        }
    }

    /**
     * Function to handle errors
     */
    function handleError(){
        validate();
    }

    /**
     * Function to validate select data
     * @returns 
     */
    function validate(){
        let errorData=null;
        if (!rescheduleReason) {
            errorData=AppConstant.help.required;
        }
        else{
            errorData=null;
        }
        setError(errorData);
        return errorData? false : true;
    }

    // ADDED BLOCK (before return)
    if (loading) {
        return <p className="p-3">Loading reasons...</p>;
    }

    return (reasons.length > 0 ?
        <div className='select-reason-wrapper w-100'>
            {showTitle ? <p className='mb-2 f-16'>Select Reason For {type} <span className='color-red'>*</span></p>: ''}
            <select className='input-control w-100' onChange={(e) => handleChange(e)} placeholder='Select' onBlur={handleError}>
                <option value={null}>Select a reason</option>
               {reasons.map((reason, index) => (
                    <option key={index} value={index}>
                        {typeof reason === "object"
                            ? `${reason.ReasonCode ?? ""} ${reason.ReasonDescription ?? ""}`.trim()
                            : reason}
                    </option>
                ))}
            </select>
            {error ? <span className='color-red f-12'>{error}</span> : ""}
            {showButton &&
                <div className='d-flex justify-content-end mt-2'>
                    <CustomButtonSS
                        isLoading={false}
                        title={AppConstant.commonStrings.next}
                        className={rescheduleReason === null ? "btn-submit disabled" : "btn-submit"}
                        onClick={() => { nextHandler() }}
                        disabled={false}
                    />
                </div>
            }
        </div> : <p className='p-3 color-red fw-bold'>{AppConstant.errors.wentWrongReLogin}</p>
    )
}

export default SelectRescheuleReason